<div class="bottom-border">
  <app-shared-header-first-panel></app-shared-header-first-panel>
  <app-shared-header-second-panel></app-shared-header-second-panel>
  <app-shared-header-third-panel></app-shared-header-third-panel>
  <!-- <app-status-graph [width]="'500px'"
  [height]="'10px'"
  [applySpaceClass]="true"></app-status-graph> -->
</div>
